import InternalLink from "components/InternalLink";
import useModalRenderer from "hooks/useModalRenderer";
import React from "react";

import ACLink from "ac-components/ACLink/ACLink";
import { ACModalV2Placement } from "ac-components/ac-modal/ACModalV2";

export const ExceptionModalCommonConfig = {
  width: 1200,
  mask: true,
  defaultPlacement: "right" as ACModalV2Placement,
};

export default function ExceptionIdCell({
  id,
  url,
  search,
  name,
  showExceptionDetail,
}: {
  id: string;
  url: string;
  search: string;
  name: string;
  showExceptionDetail?: (id: string, name: string) => void;
}) {
  const modalRenderer = useModalRenderer();
  return (
    <>
      {modalRenderer.context}
      <InternalLink
        to={`${url}/${id}${search}`}
        component={(props) => (
          <ACLink
            {...props}
            data-id={id}
            onClick={(e) => {
              if (showExceptionDetail) {
                e.preventDefault();
                showExceptionDetail(id, name);
              }
            }}
            className="ac-finding-id"
          />
        )}
      >
        EX-{id}
      </InternalLink>
    </>
  );
}
